import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.75 5.792l5.499 5.458 2.993-3.06a.911.911 0 00-.006-1.278L13.1 2.766a.911.911 0 00-1.287 0L8.75 5.792zM7.72 6.875l-4.303 4.262.01.01.072-.083-.072.084a3.843 3.843 0 00.184 5.204 3.866 3.866 0 005.735-.262l3.779-3.814L7.72 6.875zM4.354 10.36z" fill="#54585D" /></svg>);